import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative bg-white dark:bg-[#0c1427] mb-6 rounded-3xl shadow-sm border border-slate-200/60 dark:border-slate-700/60 backdrop-blur-xl overflow-hidden transition-all duration-500 hover:shadow-lg hover:shadow-slate-200/40 dark:hover:shadow-slate-900/40" }
const _hoisted_2 = { class: "relative p-6 md:p-8" }
const _hoisted_3 = { class: "flex items-center justify-between mb-8" }
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = { class: "text-xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 dark:from-slate-100 dark:to-slate-300 bg-clip-text text-transparent" }
const _hoisted_6 = { class: "text-sm text-slate-500 dark:text-slate-400 mt-1" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = ["stroke"]
const _hoisted_10 = {
  key: 0,
  class: "absolute top-full right-0 mt-3 w-56 bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-200/60 dark:border-slate-600/60 rounded-2xl shadow-xl shadow-slate-200/40 dark:shadow-slate-900/40 z-20 transform transition-all duration-300 origin-top-right"
}
const _hoisted_11 = { class: "p-2" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "w-4 h-4 ml-auto",
  fill: "#8b5cf6",
  viewBox: "0 0 20 20"
}
const _hoisted_14 = { class: "flex-1 min-h-0" }
const _hoisted_15 = {
  key: 0,
  class: "flex justify-center items-center p-12"
}
const _hoisted_16 = { class: "flex flex-col items-center gap-6" }
const _hoisted_17 = { class: "text-sm font-semibold text-slate-600 dark:text-slate-400 animate-pulse" }
const _hoisted_18 = {
  key: 1,
  class: "flex flex-col justify-center items-center p-12 text-center"
}
const _hoisted_19 = { class: "text-red-600 dark:text-red-400 font-bold text-lg mb-3" }
const _hoisted_20 = { class: "text-slate-500 dark:text-slate-400" }
const _hoisted_21 = {
  key: 2,
  class: "flex flex-col justify-center items-center p-12 text-center"
}
const _hoisted_22 = { class: "text-slate-700 dark:text-slate-300 font-bold text-lg mb-3" }
const _hoisted_23 = { class: "text-slate-500 dark:text-slate-400" }
const _hoisted_24 = {
  key: 3,
  class: "space-y-6"
}
const _hoisted_25 = { class: "relative overflow-hidden rounded-3xl bg-white/50 dark:bg-[#0c1427]/50 backdrop-blur-sm border border-slate-200/60 dark:border-slate-600/60 shadow-lg" }
const _hoisted_26 = { class: "overflow-x-auto" }
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { class: "bg-gradient-to-r from-slate-50 to-slate-100/50 dark:from-slate-800/50 dark:to-slate-700/50 border-b border-slate-200/60 dark:border-slate-600/60" }
const _hoisted_29 = { class: "text-left px-6 py-5 text-sm font-bold text-slate-700 dark:text-slate-300 first:rounded-tl-3xl" }
const _hoisted_30 = { class: "text-left px-6 py-5 text-sm font-bold text-slate-700 dark:text-slate-300" }
const _hoisted_31 = { class: "text-left px-6 py-5 text-sm font-bold text-slate-700 dark:text-slate-300" }
const _hoisted_32 = { class: "text-left px-6 py-5 text-sm font-bold text-slate-700 dark:text-slate-300" }
const _hoisted_33 = { class: "text-left px-6 py-5 text-sm font-bold text-slate-700 dark:text-slate-300 first:rounded-tl-2xl last:rounded-tr-2xl" }
const _hoisted_34 = { class: "divide-y divide-slate-200/40 dark:divide-slate-600/40" }
const _hoisted_35 = { class: "px-6 py-5" }
const _hoisted_36 = { class: "flex items-center gap-4" }
const _hoisted_37 = { class: "relative" }
const _hoisted_38 = { class: "w-12 h-12 rounded-2xl overflow-hidden bg-gradient-to-br from-slate-100 to-slate-200 dark:from-slate-700 dark:to-slate-600 border-2 border-white dark:border-slate-800 shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "font-bold text-slate-800 dark:text-slate-200 text-base" }
const _hoisted_41 = { class: "text-xs text-slate-500 dark:text-slate-400 mt-1" }
const _hoisted_42 = { class: "px-6 py-5" }
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = { class: "text-slate-600 dark:text-slate-400 font-medium" }
const _hoisted_45 = { class: "px-6 py-5" }
const _hoisted_46 = { class: "inline-flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-semibold bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300 border border-slate-200/60 dark:border-slate-600/60" }
const _hoisted_47 = { class: "px-6 py-5" }
const _hoisted_48 = { class: "flex items-center justify-center w-5 h-5 rounded-full bg-white/30 backdrop-blur-sm" }
const _hoisted_49 = {
  key: 0,
  class: "w-3 h-3",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_50 = {
  key: 1,
  class: "w-3 h-3",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_51 = {
  key: 2,
  class: "w-3 h-3",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_52 = {
  key: 3,
  class: "w-3 h-3",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_53 = {
  key: 4,
  class: "w-3 h-3",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_54 = {
  key: 5,
  class: "w-2 h-2 rounded-full bg-current"
}
const _hoisted_55 = { class: "font-bold tracking-wide" }
const _hoisted_56 = { class: "px-6 py-5" }
const _hoisted_57 = { class: "flex items-center gap-3" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_61 = { class: "text-sm font-medium text-slate-600 dark:text-slate-400 bg-slate-100/50 dark:bg-slate-700/50 px-4 py-2 rounded-xl backdrop-blur-sm border border-slate-200/60 dark:border-slate-600/60" }
const _hoisted_62 = { class: "flex items-center gap-2" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "flex items-center gap-1" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "relative z-10" }
const _hoisted_67 = {
  key: 0,
  class: "absolute inset-0 bg-gradient-to-br from-purple-600 to-indigo-700 opacity-0 hover:opacity-100 transition-opacity duration-300"
}
const _hoisted_68 = ["disabled"]
const _hoisted_69 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_70 = { class: "bg-white/95 dark:bg-slate-900/95 backdrop-blur-xl p-8 rounded-3xl shadow-2xl w-full max-w-md z-10 relative transform transition-all border border-slate-200/60 dark:border-slate-700/60" }
const _hoisted_71 = { class: "flex justify-between items-center mb-8" }
const _hoisted_72 = { class: "flex items-center gap-4" }
const _hoisted_73 = { class: "text-xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 dark:from-slate-100 dark:to-slate-300 bg-clip-text text-transparent" }
const _hoisted_74 = { class: "mb-8" }
const _hoisted_75 = { class: "text-slate-700 dark:text-slate-300 text-sm" }
const _hoisted_76 = { class: "flex justify-between items-center gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-br from-slate-50/40 to-transparent dark:from-slate-800/20 pointer-events-none" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"relative\" data-v-22198547><div class=\"w-12 h-12 rounded-2xl bg-gradient-to-br from-purple-400 via-purple-500 to-indigo-600 dark:from-purple-500 dark:via-indigo-500 dark:to-blue-600 flex items-center justify-center shadow-lg shadow-purple-200/50 dark:shadow-purple-900/30 transition-all duration-300 hover:scale-105\" data-v-22198547><svg class=\"w-6 h-6 filter drop-shadow-sm\" fill=\"none\" stroke=\"#ffffff\" viewBox=\"0 0 24 24\" data-v-22198547><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z\" data-v-22198547></path></svg></div><div class=\"absolute inset-0 w-12 h-12 rounded-2xl opacity-20 animate-pulse\" style=\"background-color:#a855f7;\" data-v-22198547></div></div>", 1)),
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.directT('dashboard.crm.recentLeads')), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.leads.length) + " " + _toDisplayString(_ctx.directT('dashboard.crm.totalLeads')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"])),
            class: _normalizeClass(["inline-flex items-center gap-3 px-5 py-3 text-sm font-semibold bg-white/70 dark:bg-slate-800/70 backdrop-blur-xl border border-slate-200/60 dark:border-slate-600/60 rounded-2xl hover:bg-white dark:hover:bg-slate-800 text-slate-700 dark:text-slate-200 transition-all duration-300 shadow-sm hover:shadow-lg hover:shadow-slate-200/40 dark:hover:shadow-slate-900/40 focus:ring-2 focus:ring-purple-500/30 focus:border-purple-300 dark:focus:border-purple-600", { 'ring-2 ring-purple-500/30 bg-white dark:bg-slate-800 shadow-lg': _ctx.isActive }])
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.selectedTimeFilter), 1),
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': _ctx.isActive }]),
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: _ctx.isActive ? '#8b5cf6' : '#64748b'
            }, _cache[12] || (_cache[12] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              }, null, -1)
            ]), 10, _hoisted_9))
          ], 2),
          (_ctx.isActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeFilters, (filter) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: filter,
                      type: "button",
                      onClick: ($event: any) => (_ctx.applyTimeFilter(filter)),
                      class: _normalizeClass(["w-full text-left px-4 py-3 text-sm font-medium rounded-xl text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700/50 transition-all duration-200 flex items-center gap-3 group", {
                  'bg-gradient-to-r from-purple-50 to-indigo-50 dark:from-purple-900/30 dark:to-indigo-900/30 text-purple-700 dark:text-purple-300 shadow-sm': _ctx.selectedTimeFilter === filter
                }])
                    }, [
                      _createElementVNode("div", {
                        class: "w-2 h-2 rounded-full transition-all duration-200",
                        style: _normalizeStyle({ backgroundColor: _ctx.selectedTimeFilter === filter ? '#8b5cf6' : 'transparent' })
                      }, null, 4),
                      _createElementVNode("span", null, _toDisplayString(filter), 1),
                      (_ctx.selectedTimeFilter === filter)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _cache[13] || (_cache[13] = [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 1.414L9 10.586 7.707 9.293a1 1 0 011.414-1.414l2 2a1 1 0 001.414 0l4-4z",
                              "clip-rule": "evenodd"
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_12))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "relative" }, [
                  _createElementVNode("div", {
                    class: "w-20 h-20 rounded-full animate-spin",
                    style: {"border":"4px solid #e2e8f0","border-top-color":"#8b5cf6"}
                  }),
                  _createElementVNode("div", {
                    class: "absolute inset-0 w-20 h-20 rounded-full animate-spin animate-reverse",
                    style: {"border":"4px solid transparent","border-right-color":"#6366f1"}
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.directT('dashboard.crm.loadingData')), 1)
              ])
            ]))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "w-20 h-20 mx-auto mb-6 rounded-3xl bg-gradient-to-br from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-800/20 flex items-center justify-center border border-red-200/60 dark:border-red-800/60" }, [
                  _createElementVNode("svg", {
                    class: "w-10 h-10",
                    fill: "none",
                    stroke: "#ef4444",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.directT('dashboard.crm.unableToLoadLeads')), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.error), 1)
              ]))
            : (_ctx.leads.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "w-20 h-20 mx-auto mb-6 rounded-3xl bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-700 flex items-center justify-center border border-slate-200/60 dark:border-slate-600/60" }, [
                    _createElementVNode("svg", {
                      class: "w-10 h-10",
                      fill: "none",
                      stroke: "#94a3b8",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.directT('dashboard.crm.noLeadsFound')), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.directT('dashboard.crm.tryChangingFilter')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("table", _hoisted_27, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_28, [
                            _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.directT('dashboard.customer')), 1),
                            _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.directT('dashboard.crm.email')), 1),
                            _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.directT('dashboard.crm.source')), 1),
                            _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.directT('dashboard.status')), 1),
                            _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.directT('dashboard.crm.action')), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", _hoisted_34, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.id,
                              class: "hover:bg-slate-50/50 dark:hover:bg-slate-700/30 transition-all duration-300 group"
                            }, [
                              _createElementVNode("td", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("img", {
                                        src: _ctx.getLeadAvatar(item),
                                        class: "w-full h-full object-cover",
                                        alt: "user-image"
                                      }, null, 8, _hoisted_39)
                                    ]),
                                    _cache[17] || (_cache[17] = _createElementVNode("div", {
                                      class: "absolute -bottom-0.5 -right-0.5 w-4 h-4 border-2 border-white dark:border-slate-800 rounded-full",
                                      style: {"background-color":"#10b981"}
                                    }, null, -1))
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_40, _toDisplayString(item.name), 1),
                                    _createElementVNode("div", _hoisted_41, "ID: " + _toDisplayString(item.id), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  _cache[18] || (_cache[18] = _createElementVNode("svg", {
                                    class: "w-4 h-4",
                                    fill: "none",
                                    stroke: "#94a3b8",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                                    })
                                  ], -1)),
                                  _createElementVNode("span", _hoisted_44, _toDisplayString(item.email), 1)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, [
                                  _cache[19] || (_cache[19] = _createElementVNode("div", {
                                    class: "w-2 h-2 rounded-full",
                                    style: {"background-color":"#94a3b8"}
                                  }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.source), 1)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_47, [
                                _createElementVNode("div", {
                                  class: "relative inline-flex items-center gap-3 px-4 py-2.5 rounded-2xl text-sm font-bold backdrop-blur-sm transition-all duration-300 hover:scale-105 cursor-pointer group/status border shadow-sm",
                                  style: _normalizeStyle(_ctx.getEnhancedStatusStyle(item.status))
                                }, [
                                  _createElementVNode("div", _hoisted_48, [
                                    (item.status?.toLowerCase() === 'new')
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_49, _cache[20] || (_cache[20] = [
                                          _createElementVNode("path", {
                                            "fill-rule": "evenodd",
                                            d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                            "clip-rule": "evenodd"
                                          }, null, -1)
                                        ])))
                                      : (['in progress', 'qualified', 'close'].includes(item.status?.toLowerCase()))
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_50, _cache[21] || (_cache[21] = [
                                            _createElementVNode("path", {
                                              "fill-rule": "evenodd",
                                              d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
                                              "clip-rule": "evenodd"
                                            }, null, -1)
                                          ])))
                                        : (item.status?.toLowerCase() === 'pending')
                                          ? (_openBlock(), _createElementBlock("svg", _hoisted_51, _cache[22] || (_cache[22] = [
                                              _createElementVNode("path", {
                                                "fill-rule": "evenodd",
                                                d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
                                                "clip-rule": "evenodd"
                                              }, null, -1)
                                            ])))
                                          : (['rejected', 'closed lost'].includes(item.status?.toLowerCase()))
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_52, _cache[23] || (_cache[23] = [
                                                _createElementVNode("path", {
                                                  "fill-rule": "evenodd",
                                                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                                  "clip-rule": "evenodd"
                                                }, null, -1)
                                              ])))
                                            : (item.status?.toLowerCase() === 'closed')
                                              ? (_openBlock(), _createElementBlock("svg", _hoisted_53, _cache[24] || (_cache[24] = [
                                                  _createElementVNode("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" }, null, -1)
                                                ])))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_54))
                                  ]),
                                  _createElementVNode("span", _hoisted_55, _toDisplayString(item.status), 1),
                                  _createElementVNode("div", {
                                    class: "absolute inset-0 rounded-2xl opacity-20 animate-pulse group-hover/status:animate-none",
                                    style: _normalizeStyle({ backgroundColor: _ctx.getStatusBaseColor(item.status) })
                                  }, null, 4)
                                ], 4)
                              ]),
                              _createElementVNode("td", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.editLead(item)),
                                    class: "w-10 h-10 rounded-2xl text-white hover:scale-110 transition-all duration-300 flex items-center justify-center group shadow-lg hover:shadow-xl",
                                    style: {"background":"linear-gradient(135deg, #3b82f6, #2563eb)","box-shadow":"0 4px 12px rgba(59, 130, 246, 0.3)"},
                                    onMouseover: _cache[1] || (_cache[1] = ($event: any) => ($event.target.style.boxShadow = '0 8px 25px rgba(59, 130, 246, 0.4)')),
                                    onMouseout: _cache[2] || (_cache[2] = ($event: any) => ($event.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)'))
                                  }, _cache[25] || (_cache[25] = [
                                    _createElementVNode("svg", {
                                      class: "w-4 h-4 group-hover:scale-110 transition-transform filter drop-shadow-sm",
                                      fill: "none",
                                      stroke: "#ffffff",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                      })
                                    ], -1)
                                  ]), 40, _hoisted_58),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.deleteLead(item)),
                                    class: "w-10 h-10 rounded-2xl text-white hover:scale-110 transition-all duration-300 flex items-center justify-center group shadow-lg hover:shadow-xl",
                                    style: {"background":"linear-gradient(135deg, #ef4444, #dc2626)","box-shadow":"0 4px 12px rgba(239, 68, 68, 0.3)"},
                                    onMouseover: _cache[3] || (_cache[3] = ($event: any) => ($event.target.style.boxShadow = '0 8px 25px rgba(239, 68, 68, 0.4)')),
                                    onMouseout: _cache[4] || (_cache[4] = ($event: any) => ($event.target.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.3)'))
                                  }, _cache[26] || (_cache[26] = [
                                    _createElementVNode("svg", {
                                      class: "w-4 h-4 group-hover:scale-110 transition-transform filter drop-shadow-sm",
                                      fill: "none",
                                      stroke: "#ffffff",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      })
                                    ], -1)
                                  ]), 40, _hoisted_59)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.totalPages > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.directT('dashboard.crm.showingResultsFromTo').replace('{start}', String(_ctx.startItem + 1)).replace('{end}', String(_ctx.endItem)).replace('{total}', String(_ctx.leads.length))), 1),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                            disabled: _ctx.currentPage === 1,
                            class: "px-4 py-2.5 text-sm font-bold rounded-xl border transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed bg-white/70 dark:bg-slate-800/70 backdrop-blur-xl border-slate-200/60 dark:border-slate-600/60 text-slate-700 dark:text-slate-200 hover:bg-white dark:hover:bg-slate-800 hover:shadow-lg hover:shadow-slate-200/40 dark:hover:shadow-slate-900/40 disabled:hover:shadow-none"
                          }, " קודם ", 8, _hoisted_63),
                          _createElementVNode("div", _hoisted_64, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: page,
                                onClick: ($event: any) => (_ctx.goToPage(page)),
                                class: _normalizeClass(["w-12 h-12 text-sm font-bold rounded-xl transition-all duration-300 relative overflow-hidden", {
                    'bg-gradient-to-br from-purple-500 to-indigo-600 text-white shadow-lg shadow-purple-200/50 dark:shadow-purple-900/30 scale-110': page === _ctx.currentPage,
                    'bg-white/70 dark:bg-slate-800/70 backdrop-blur-xl border border-slate-200/60 dark:border-slate-600/60 text-slate-700 dark:text-slate-200 hover:bg-white dark:hover:bg-slate-800 hover:shadow-lg': page !== _ctx.currentPage
                  }])
                              }, [
                                _createElementVNode("span", _hoisted_66, _toDisplayString(page), 1),
                                (page === _ctx.currentPage)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_65))
                            }), 128))
                          ]),
                          _createElementVNode("button", {
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                            disabled: _ctx.currentPage === _ctx.totalPages,
                            class: "px-4 py-2.5 text-sm font-bold rounded-xl border transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed bg-white/70 dark:bg-slate-800/70 backdrop-blur-xl border-slate-200/60 dark:border-slate-600/60 text-slate-700 dark:text-slate-200 hover:bg-white dark:hover:bg-slate-800 hover:shadow-lg hover:shadow-slate-200/40 dark:hover:shadow-slate-900/40 disabled:hover:shadow-none"
                          }, " הבא ", 8, _hoisted_68)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
      ])
    ]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/20 backdrop-blur-md",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _cache[27] || (_cache[27] = _createElementVNode("div", {
                  class: "w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg",
                  style: {"background":"linear-gradient(135deg, #ef4444, #dc2626)","box-shadow":"0 4px 12px rgba(239, 68, 68, 0.3)"}
                }, [
                  _createElementVNode("svg", {
                    class: "w-6 h-6",
                    fill: "none",
                    stroke: "#ffffff",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                    })
                  ])
                ], -1)),
                _createElementVNode("h3", _hoisted_73, _toDisplayString(_ctx.directT('dashboard.crm.confirmDeletion')), 1)
              ]),
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 p-2 -m-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
              }, _cache[28] || (_cache[28] = [
                _createElementVNode("svg", {
                  class: "w-5 h-5",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.directT('dashboard.crm.deleteConfirmation')), 1)
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "flex-1 py-3 px-4 bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300 transition-all hover:bg-slate-200 dark:hover:bg-slate-600 rounded-2xl font-semibold"
              }, _toDisplayString(_ctx.directT('dashboard.crm.cancel')), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                class: "flex-1 py-3 px-4 text-white transition-all rounded-2xl shadow-lg font-semibold",
                style: {"background":"linear-gradient(135deg, #ef4444, #dc2626)","box-shadow":"0 4px 12px rgba(239, 68, 68, 0.3)"}
              }, _toDisplayString(_ctx.directT('dashboard.crm.delete')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}